(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chaowk-footer-v2"] && !Shopify.designMode) return;
  try {
    
  const creamFooterViewport = window.matchMedia('(min-width: 750px)');
  function syncCreamFooter() {
    document.querySelectorAll('.cw-footer__details').forEach((menu) => { menu.open = creamFooterViewport.matches; });
  }
  syncCreamFooter();
  creamFooterViewport.addEventListener('change', syncCreamFooter);
  document.addEventListener('shopify:section:load', syncCreamFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chaowk-footer"] && !Shopify.designMode) return;
  try {
    
  const footerViewport = window.matchMedia('(min-width: 750px)');
  function syncFooterMenus() {
    document.querySelectorAll('.chaowk-footer__nav details').forEach((menu) => {
      menu.open = footerViewport.matches;
    });
  }
  syncFooterMenus();
  footerViewport.addEventListener('change', syncFooterMenus);
  document.addEventListener('shopify:section:load', syncFooterMenus);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chaowk-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cw-brand-carousel')) {
  customElements.define('cw-brand-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('.cw-brand-carousel__track');
      const prev = this.querySelector('[data-cw-prev]');
      const next = this.querySelector('[data-cw-next]');
      const cards = [...track.children];
      if (!cards.length) return;
      const rtl = getComputedStyle(track).direction === 'rtl';
      const update = () => {
        const box = track.getBoundingClientRect();
        const first = cards[0].getBoundingClientRect();
        const last = cards.at(-1).getBoundingClientRect();
        prev.disabled = rtl ? first.right <= box.right + 2 : first.left >= box.left - 2;
        next.disabled = rtl ? last.left >= box.left - 2 : last.right <= box.right + 2;
        this.querySelector('.cw-brand-carousel__buttons').hidden = track.scrollWidth <= track.clientWidth + 2;
      };
      const move = (forward) => {
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: (forward ? 1 : -1) * (rtl ? -1 : 1) * track.clientWidth * .85, behavior: reduced ? 'auto' : 'smooth' });
      };
      prev.addEventListener('click', () => move(false), options);
      next.addEventListener('click', () => move(true), options);
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(rtl ? event.key === 'ArrowLeft' : event.key === 'ArrowRight');
      }, options);
      let drag = null;
      let suppressClick = false;
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button,input,select')) return;
        suppressClick = false;
        drag = { x: event.clientX, scroll: track.scrollLeft, active: false, id: event.pointerId };
      }, options);
      track.addEventListener('pointermove', (event) => {
        if (!drag) return;
        const delta = event.clientX - drag.x;
        if (!drag.active && Math.abs(delta) < 6) return;
        drag.active = true;
        suppressClick = true;
        track.setPointerCapture(drag.id);
        track.classList.add('is-dragging');
        track.scrollLeft = drag.scroll - delta;
      }, options);
      const finish = () => { drag = null; track.classList.remove('is-dragging'); };
      track.addEventListener('pointerup', finish, options);
      track.addEventListener('pointercancel', finish, options);
      track.addEventListener('lostpointercapture', finish, options);
      track.addEventListener('pointerleave', () => { if (drag && !drag.active) finish(); }, options);
      track.addEventListener('dragstart', (event) => event.preventDefault(), options);
      track.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, { capture: true, signal: this.controller.signal });
      track.addEventListener('scroll', update, { passive: true, signal: this.controller.signal });
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
